const fetchBase = window.location.hostname === "localhost"

    ? "http://localhost:8082"
    : "https://ouralife.net";

export default fetchBase;